export function formatViews(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  return `${value}`;
}

export function heatLabel(value: number): string {
  if (value >= 95) return "爆";
  if (value >= 90) return "烫";
  if (value >= 85) return "热";
  if (value >= 80) return "温";
  return "新鲜";
}

export function formatDate(value: string): string {
  const parts = value.split("-");
  if (parts.length === 3) {
    return `${parts[0]} 年 ${Number(parts[1])} 月 ${Number(parts[2])} 日`;
  }
  return value;
}